import { useDispatch, useSelector } from 'react-redux';
import useReactRouter from 'use-react-router';
import { CHATBOT_EDITOR } from '../../../common/constants/routes';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import usersCRUDActions from '@mm/state/actions/UsersCRUDActions';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import modalActions from '@mm/state/modules/modalsState/actions';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';

export const useOpenOnboardingErrorModal = () => {
  const dispatch = useDispatch();
  const { history } = useReactRouter();
  const companyId = useSelector(selectActiveCompanyId);
  const session = useSelector((state: StoreState) => state.session.session);
  const activeChatBot = useSelector(
    (state: StoreState) => state.chatbot.activeChatbot,
  );

  const openOnboardingErrorModal = () => {
    const completeOnboarding = async () => {
      await dispatch(
        usersCRUDActions.updateUserAttributes(companyId, session.id, {
          onboardingSignupStep: OnboardingSignupStep.NONE,
        }),
      );

      const route = activeChatBot
        ? BotBuilderRoutes.build.getLink({ chatbotId: activeChatBot.id })
        : CHATBOT_EDITOR;

      dispatch(modalActions.closeModal());
      history.push(route);
    };

    dispatch(
      modalActions.openPrettyErrorModal({
        title: 'Oops Something went wrong',
        buttonText: 'Go to Bot Builder',
        onClose: completeOnboarding,
      }),
    );
  };

  return { openOnboardingErrorModal };
};
